import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import api from '../../utils/api';

const Register: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }

    setLoading(true);

    try {
      const { data } = await api.post('/auth/register', {
        email: formData.email,
        username: formData.username,
        password: formData.password,
      });
      if (!mountedRef.current) return;
      localStorage.setItem('token', data.token);
      dispatch({ type: 'REGISTER_SUCCESS', payload: data });
      history.push('/');
    } catch (err: any) {
      if (!mountedRef.current) return;
      setError(err.response?.data?.message || '注册失败，请重试');
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2 className="auth-title">注册</h2>
        
        {error && (
          <div style={{ 
            color: '#ff4d4f', 
            marginBottom: '16px', 
            padding: '8px',
            background: '#fff2f0',
            borderRadius: '4px'
          }}>
            {error}
          </div>
        )}

        <div className="form-group">
          <label className="form-label">邮箱</label>
          <input
            type="email"
            className="form-input"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="请输入邮箱"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">用户名</label>
          <input
            type="text"
            className="form-input"
            value={formData.username}
            onChange={(e) => setFormData({ ...formData, username: e.target.value })}
            placeholder="请输入用户名"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">密码</label>
          <input
            type="password"
            className="form-input"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            placeholder="请输入密码（至少6位）"
            minLength={6}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">确认密码</label>
          <input
            type="password"
            className="form-input"
            value={formData.confirmPassword}
            onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
            placeholder="请再次输入密码"
            required
          />
        </div>

        <button 
          type="submit" 
          className="btn btn-primary" 
          style={{ width: '100%', marginTop: '16px' }}
          disabled={loading}
        >
          {loading ? '注册中...' : '注册'}
        </button>

        <p style={{ marginTop: '16px', textAlign: 'center', color: '#666' }}>
          已有账号？ <Link to="/login" style={{ color: '#1890ff' }}>立即登录</Link>
        </p>
      </form>
    </div>
  );
};

export default Register;
